import {Constants} from '../components/view-constants.js';

const STORAGE_KEY = 'sizeFilterPersistence';
const SIZE_FILTER_IDENTIFIER = 'groesse';
const SIZE_FILTER_PARAM = `${Constants.FILTER_PARAM_PREFIX}${SIZE_FILTER_IDENTIFIER}`;

// Upper Part shops
const UPPER_PART_SHOPS = [
    5906,  // Kleider
    5506,  // Shirts & Tops
    5899,  // Blusen & Tuniken
    5494,  // Pullover & Strickjacken
    5501,  // Jacken & Mäntel
    5504,  // Blazer
    17026, // Jumpsuits
];

// Lower Part shops
const LOWER_PART_SHOPS = [
    5489,   // Jeans
    5497,   // Hosen
    5903,   // Röcke
    703883, // Shorts
];

/**
 * Returns the shop group ('upper' or 'lower') for a given shopId,
 * or null if the shop is not in any group.
 * Also checks if the shop is a sub-shop of any group shop via filterRootShopId.
 */
function getShopGroup(shopId, filterRootShopId) {
    const effectiveShopId = filterRootShopId || shopId;

    if (UPPER_PART_SHOPS.includes(effectiveShopId)) {
        return 'upper';
    }
    if (LOWER_PART_SHOPS.includes(effectiveShopId)) {
        return 'lower';
    }
    return null;
}

function getStoredSizeFilter(group) {
    if (!group) return null;
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (!stored) return null;

        const data = JSON.parse(stored);
        return data[group]?.values || null;
    } catch (e) {
        return null;
    }
}

function getStoredSourceShopId(group) {
    if (!group) return null;
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (!stored) return null;

        const data = JSON.parse(stored);
        return data[group]?.sourceShopId || null;
    } catch (e) {
        return null;
    }
}

function storeSizeFilter(group, sizeValues, sourceShopId) {
    if (!group) return;

    let data = {};
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                data = parsed;
            }
        }
    } catch (e) {
        data = {};
    }

    if (sizeValues && sizeValues.length > 0) {
        data[group] = {
            values: sizeValues,
            sourceShopId: sourceShopId
        };
    } else {
        delete data[group];
    }

    if (Object.keys(data).length > 0) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } else {
        sessionStorage.removeItem(STORAGE_KEY);
    }
}

function clearSizeFilter(group) {
    storeSizeFilter(group, null);
}

function saveSizeFilterFromParams(searchParams, shopId, filterRootShopId) {
    const group = getShopGroup(shopId, filterRootShopId);
    if (!group) return;

    const sizeValues = searchParams.getAll(SIZE_FILTER_PARAM);
    storeSizeFilter(group, sizeValues, shopId);
}

function hasSizeFilterInParams(searchParams) {
    return searchParams.has(SIZE_FILTER_PARAM);
}

/**
 * Applies stored size filter to URL params
 * Returns new URLSearchParams with size filter applied, or original if not applicable
 */
function applyStoredSizeFilterToParams(searchParams, shopId, filterRootShopId) {
    const group = getShopGroup(shopId, filterRootShopId);
    if (!group) return searchParams;

    // Don't apply if URL already has size filter
    if (hasSizeFilterInParams(searchParams)) return searchParams;

    const storedFilter = getStoredSizeFilter(group);
    if (!storedFilter || storedFilter.length === 0) return searchParams;

    const newParams = new URLSearchParams(searchParams);
    storedFilter.forEach(value => {
        newParams.append(SIZE_FILTER_PARAM, value);
    });

    return newParams;
}

function shouldApplyStoredSizeFilter(searchParams, shopId, filterRootShopId) {
    const group = getShopGroup(shopId, filterRootShopId);
    if (!group) return false;

    // Don't apply if URL already has size filter
    if (hasSizeFilterInParams(searchParams)) return false;

    const storedFilter = getStoredSizeFilter(group);
    return storedFilter && storedFilter.length > 0;
}

export {
    getShopGroup,
    getStoredSourceShopId,
    clearSizeFilter,
    saveSizeFilterFromParams,
    applyStoredSizeFilterToParams,
    shouldApplyStoredSizeFilter,
};
